// @flow strict

import { isNullOrUndefined } from '../../templates/FreeTrialThankYou/UserProfileForm/utils';
import { useSegment } from './use-segment';

export const SupportedTrackingFieldNames = {
  ExcludeData: {
    FirstName: 'FirstName',
    LastName: 'LastName',
    PhoneNumber: 'PhoneNumber',
    Password: 'Password',
    Email: 'Email',
    PinCode: 'PinCode',
  },
  IncludeData: {
    JobTitle: 'JobTitle',
    Location: 'Location',
    CompanyName: 'CompanyName',
  },
};

export const track = (event: string, properties: ?Object): void => {
  useSegment(s => s.track(event, properties));
};

const shouldIgnoreFilledEvent = (dataValue: any): boolean =>
  isNullOrUndefined(dataValue) || dataValue === '';

export function identify(profileId: string, email: string) {
  useSegment(segment => {
    segment.identify(profileId, { email });
  });
}

export function raiseFilledEventExcludeData(dataValue: any, fieldName: string) {
  if (shouldIgnoreFilledEvent(dataValue)) {
    return;
  }

  track(`Platform Profile ${fieldName} Filled`);
}

export function raiseFilledEventIncludeData(dataValue: any, fieldName: string) {
  if (shouldIgnoreFilledEvent(dataValue)) {
    return;
  }

  const obj = {};
  obj[fieldName] = dataValue;

  track(`Platform Profile ${fieldName} Filled`, obj);
}

export const raiseUserSubmitEvent = (actionName: string): void =>
  track(`Platform Profile ${actionName}`);

export const raiseEventWithData = (eventName: string, data: Object): void =>
  track(`Platform Profile ${eventName}`, data);
